import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, reactive, toRaw, onBeforeMount, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import DetailForm from './components/DetailForm.vue'
import type { FbuSalesClueEditParams } from '@/typings/api/clueManage'
import { useI18n } from 'vue-i18n'
import { newClientEvaluationDetail, newClientEvaluationReviewHistory } from '@/api/overseasSales/newClientEvaluation'

const __default__ = { name: 'DcCosOFbuNewClientEvaluationView' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18n()
const router = useRouter()
const route = useRoute()
const queryClueId = computed(() => route.query.newClientId as unknown as number)
const dataForm = reactive<FbuSalesClueEditParams.RootObject>({
  contact: {},
  business: {
    demandInfo: { warehouses: [{}] },
    saleInfo: [{}],
    quotationInfo: { details: [{}] },
    contractInfo: { fixedCredit: {}, registrationFee: {}, monthlyMaintenanceFee: {} }
  },
  visitAddress: [{}]
})
const reviewHistory = ref<any[]>([])
const fetchReviewHistory = async () => {
  const res = await newClientEvaluationReviewHistory({ id: route.query.newClientId as unknown as number })
  reviewHistory.value = res.data
}
const getDetails = () => {
  newClientEvaluationDetail({ id: route.query.newClientId as unknown as number }).then((res) => {
    if (res.data.business && res.data.business.businessType && res.data.business.businessType?.length > 0) {
      res.data.business.businessTypeSelect = res.data.business.businessType[0]
    }
    Object.assign(dataForm, res.data)
  })
}

onBeforeMount(() => {
  getDetails()
  fetchReviewHistory()
})

const goToEdit = () => {
  router.push({ path: '/ofbu/newClientEvaluation/edit', query: { newClientId: queryClueId.value } })
}

return (_ctx: any,_cache: any) => {
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _component_SellerButton = _resolveComponent("SellerButton")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_dc_layout_main, null, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_content, null, {
          default: _withCtx(() => [
            _createVNode(DetailForm, {
              ref: "detailFormRef",
              type: "view",
              isEdit: false,
              value: dataForm,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm) = $event)),
              reviewHistory: reviewHistory.value
            }, null, 8, ["value", "reviewHistory"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_cos_footer_button, { hideOk: true }, {
      default: _withCtx(() => [
        (dataForm.auditStatus === 11)
          ? _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
              key: 0,
              controlType: "none",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (goToEdit()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('btn.review')), 1)
              ]),
              _: 1
            })), [
              [_directive_permission, 'ofbu_new_client_evaluation_submit_review_btn']
            ])
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})